import { NavigationModel } from "models/NavigationModel";

import { getLinkTextSupport, getLinkTextVivaEngage } from "./translations";

export function getSupportLinks(): NavigationModel[] {
  return [
    {
      href: "https://confluence.sbb.ch/display/EGPL/Support",
      text: getLinkTextSupport(),
      iconStart: <i className="ms-Icon ms-Icon--SentimentAnalysis" />,
      isSelected: false,
      target: "_blank",
    },
    {
      href: "https://web.yammer.com/main/org/sbb.ch/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMTE0MTI1OTI2NCJ9/all",
      text: getLinkTextVivaEngage(),
      iconStart: <i className="ms-Icon ms-Icon--YammerLogo" />,
      isSelected: false,
      target: "_blank",
    },
  ];
}
